export default "__VITE_ASSET__D3JC_Hme__"